import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdCard } from '@fortawesome/pro-regular-svg-icons/faIdCard';

import { Button, ButtonType } from '../../components';
import { useDependencies } from '../../dependencies';

export const Verified = (): JSX.Element => {
  const { stores, services: { tracker } } = useDependencies();
  const { t } = useTranslation();
  const { verification } = stores;

  // Mirrors Angular verification-service.js:46 — fires once when the user
  // sees the "verified" state of the modal so funnel analytics can attribute
  // the pass to the modal session.
  const tracked = useRef(false);
  useEffect(() => {
    if (tracked.current) return;
    tracked.current = true;
    tracker.track('verification-modal', { action: 'stripe-verification-passed' });
  }, [tracker]);

  const clickContinue = (): void => {
    if (verification.callback) {
      verification.callback();
    }
  }

  return (
    <div>
      <div className='font-bold text-xl mb-5'><FontAwesomeIcon icon={faIdCard} /> {t('identityCheck.verified.header')}</div>
      <div className='mb-4'>{t('identityCheck.verified.description')}</div>
      <div className='mb-4'>
        <Button
          buttonType={ButtonType.primary}
          onClick={clickContinue}>
          {t('identityCheck.verified.continue')}
        </Button>
      </div>
    </div>
  );
};
